import React from "react";
import { Div } from "../../atoms/Div";
import { Button } from "../../atoms/Button";
import Collapse from '@material-ui/core/Collapse';



const FailModal = ({ fail, closeModals}) => {

    return (
        <Collapse in={fail.collapse}>
            <Div className="fail-modal">
                <Div className="fail-modal__left-side">
                    <Div className="fail-modal__icon-info">
                    </Div>
                    <Div className="fail-modal__main-text">
                        {fail.text}
                    </Div>
                </Div>
                <Div className="fail-modal__right-side">
                    <Button className="fail-modal__close-button" onClick={closeModals}/>
                </Div>
            </Div>
        </Collapse>
    );
};

export default FailModal;

